import React from "react";
import Decorator from "@evertrue/client-decorator";
import PropTypes from "prop-types";
import ContactDisplayCard from "./contact-display-card";

const ContactCard = ({ contact, ...rest }) => {
  const formattedName = Decorator.Contacts.getFullName(contact);
  const roleWithYear = Decorator.Profile.getRoleWithYear(contact);
  return <ContactDisplayCard formattedName={formattedName} roleWithYear={roleWithYear} contact={contact} {...rest} />;
};

ContactCard.propTypes = {
  contact: PropTypes.object,
};

ContactCard.defaultProps = {
  contact: {},
};

ContactCard.displayName = "ContactCard";

export default ContactCard;
